import fs from 'node:fs';
import path from 'node:path';
import { writePrivateFileSync } from './private-file.js';

export interface BootstrapSessionState {
  version: 1;
  endpoint: string;
  authenticated_at: number;
  /**
   * Session cookie pair returned by Platform API bootstrap consume/login.
   * Stored as "session=<signed-id>" for CLI-authenticated API requests.
   */
  session_cookie?: string;
  user: {
    id: string;
    email: string;
    role: string;
  };
  account: {
    id: string;
    slug?: string;
    tier?: string;
  };
}

const STATE_RELATIVE_PATH = path.join('.agents', 'bootstrap-session.json');

export function getBootstrapStatePath(projectPath: string): string {
  return path.join(projectPath, STATE_RELATIVE_PATH);
}

export function loadBootstrapState(projectPath: string): BootstrapSessionState | null {
  const statePath = getBootstrapStatePath(projectPath);
  if (!fs.existsSync(statePath)) return null;

  try {
    const parsed = JSON.parse(fs.readFileSync(statePath, 'utf-8')) as BootstrapSessionState;
    if (parsed.version !== 1) return null;
    if (!parsed.endpoint || !parsed.user?.id || !parsed.account?.id) return null;
    if (parsed.session_cookie !== undefined && typeof parsed.session_cookie !== 'string') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function persistBootstrapState(projectPath: string, state: BootstrapSessionState): void {
  const statePath = getBootstrapStatePath(projectPath);
  fs.mkdirSync(path.dirname(statePath), { recursive: true });
  writePrivateFileSync(statePath, JSON.stringify(state, null, 2) + '\n');
}

export function clearBootstrapState(projectPath: string): void {
  const statePath = getBootstrapStatePath(projectPath);
  if (fs.existsSync(statePath)) {
    fs.unlinkSync(statePath);
  }
}
